// extracted by mini-css-extract-plugin
module.exports = {"hz-Listing-details-button":"ListingDetailsButton_hz-Listing-details-button__UVAuN"};